import React from "react";
import Layout from "../shared/components/Layout";
import SubPageBanner from "../shared/sections/SubPageBanner";
import FeedbackSection from "../shared/sections/FeedbackSection";
import ClientBannerSection from "../shared/sections/ClientBannerSection";
import EventDetailSection from "../shared/sections/EventDetailSection";

const EventDetails = () => {
	return (
		<Layout>
			<SubPageBanner title="Education Make a Life for Poor Children!" />
			<EventDetailSection />
			<FeedbackSection />
			<ClientBannerSection noHead />
		</Layout>
	);
};

export default EventDetails;
